/**
 * Stripe elements styles config
 */
export default {
    style: {
        base: {
            color: '#32325d',
            fontFamily: 'Europa, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '18px',
            '::placeholder': {
                color: '#A29FAF',
            },
            ':-webkit-autofill': {
                color: '#A29FAF',
            },
        },
        invalid: {
            color: '#DF2A4A',
            iconColor: '#DF2A4A',
            ':-webkit-autofill': {
                color: '#DF2A4A',
            },
        },
    },
};
